// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductLabel_container__HpSOF","vendor":"ProductLabel_vendor__Cgw6v","text":"ProductLabel_text__IpPJj"};